import { render, staticRenderFns } from "./GroupMindFile.vue?vue&type=template&id=79c597a2&scoped=true"
import script from "./GroupMindFile.vue?vue&type=script&lang=js"
export * from "./GroupMindFile.vue?vue&type=script&lang=js"
import style0 from "./GroupMindFile.vue?vue&type=style&index=0&id=79c597a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c597a2",
  null
  
)

export default component.exports